export const AI_PROMPT_MAX_LENGTH = 100;

// Re-export from shared constants
export { AI_PROMPT_QUERY_KEY } from '@/shared/constants/aiPrompt.constants';
